export interface EnvConfig {
    api_url: string;
    CLIENT_ID: string;
    redirect_url: string;
    FB_CONSUMER_ID: string;
    FB_BUSINESS_ID: string;
    fb_redirect_url: string;
    INSTA_CONSUMER_ID: string;
    insta_redirect_url: string;
    TWITTER_CONSUMER_ID: string;
    twitter_redirect_url: string;
  }
  
  export class AppConfig {
    static getConfig(): EnvConfig {
      const host = window.location.hostname;
  
      if (host.includes('localhost')) {
        return {
          api_url: 'http://65.2.172.250:80/api/v1/',
          CLIENT_ID: '86l729xzrbvofv',
          redirect_url: 'http://localhost:4200/linkedin-callback/',
          FB_CONSUMER_ID: '989345853157733',
          FB_BUSINESS_ID: '954626393490263',
          fb_redirect_url: 'http://localhost:4200/facebook-callback/',
          INSTA_CONSUMER_ID: '1068669295430528',
          insta_redirect_url: 'https://localhost:4200/instagram-callback/',
          TWITTER_CONSUMER_ID: 'Vm5qZzkyTUpERHJKZHBDNzJMeGc6MTpjaQ',
          twitter_redirect_url: 'https://localhost:4200/twitter-callback/'
        };
      } else if (host.includes('65.2.172.250')) {
        return {
          api_url: 'http://65.2.172.250/api/v1/',
          CLIENT_ID: '86l729xzrbvofv',
          redirect_url: 'http://65.2.172.250:82/linkedin-callback/',
          FB_CONSUMER_ID: '989345853157733',
          FB_BUSINESS_ID: '954626393490263',
          fb_redirect_url: 'http://65.2.172.250:82/facebook-callback/',
          INSTA_CONSUMER_ID: '1068669295430528',
          insta_redirect_url: 'http://65.2.172.250:82/instagram-callback/',
          TWITTER_CONSUMER_ID: 'Vm5qZzkyTUpERHJKZHBDNzJMeGc6MTpjaQ',
          twitter_redirect_url: 'http://65.2.172.250:82/twitter-callback/'
        };
      } else if (host.includes('web.archivemyria.com')) {
        return {
          api_url: 'https://api.archivemyria.com/api/v1/',
          CLIENT_ID: '86l729xzrbvofv',
          redirect_url: 'https://web.archivemyria.com/linkedin-callback/',
          FB_CONSUMER_ID: '943839941190646',
          FB_BUSINESS_ID: '744954504590324',
          fb_redirect_url: 'https://web.archivemyria.com/facebook-callback/',
          INSTA_CONSUMER_ID: '1068669295430528',
          insta_redirect_url: 'https://web.archivemyria.com/instagram-callback/',
          TWITTER_CONSUMER_ID: 'Vm5qZzkyTUpERHJKZHBDNzJMeGc6MTpjaQ',
          twitter_redirect_url: 'https://web.archivemyria.com/twitter-callback/'
        };
      } else {
        // default fallback (same as your 65.2.172.250 IPs)
        return {
          api_url: 'http://65.2.172.250:80/api/v1/',
          CLIENT_ID: '86asdasdl729sdasdxzrbvofv',
          redirect_url: 'http://65.2.172.250:82/linkedin-callback/',
          FB_CONSUMER_ID: '98234233243329dfhdfgdfgdfgdf345853157733',
          FB_BUSINESS_ID: '954626394564643490263',
          fb_redirect_url: 'http://65.2.172.250:82/facebook-callback/',
          INSTA_CONSUMER_ID: '1068669295430528',
          insta_redirect_url: 'http://65.2.172.250:82/instagram-callback/',
          TWITTER_CONSUMER_ID: 'Vm5qZzkyTUpERHJKZHBDNzJMeGc6MTpjaQ',
          twitter_redirect_url: 'http://65.2.172.250:82/twitter-callback/'
        };
      }
    }
  }
  